/**
 *  Created by piotr@revisual.io on 04/08/2025
 */
import { useSubscriptionPlansStore } from "../../../../hooks/redux/subscriptionPlans";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import SubscriptionPlanColumn from "../../component/Subscription/SubscriptionPlanColumn";
import useSwipe from "./useSwipe";
import { updateAppTag } from "../../../../actions/appTags";
import { useAppTagStore } from "../../../../hooks/redux/appTags";
import { useCurrentOrganizationStore } from "../../../../hooks/redux/currentOrganization";
import appConfig from "../../../../appConfig";
import { FreePlanConfig, FreePlanPrice } from "../../consts/pricing";

export const ActivateTrialStep = ({ form, setFormField }) => {
  const { subscriptionPlans } = useSubscriptionPlansStore();
  const { currentOrganization } = useCurrentOrganizationStore();

  const [currency, setCurrency] = useState("usd");
  const containerRef = useRef(null);
  const { updateAppTag } = useAppTagStore();
  const [formDisabled, setFormDisabled] = useState(false);
  const [selectedPrice, setSelectedPrice] = useState(null);

  useEffect(() => {
    updateAppTag("company", "_activate_step_accessed");
  }, []);

  useEffect(() => {
    if (formDisabled && selectedPrice && !currentOrganization.activateTrial) {
      setFormField("plan")(selectedPrice);
    }
  }, [formDisabled, selectedPrice, currentOrganization.activateTrial]);

  useEffect(() => {
    if (currentOrganization.activateTrialError) {
      setFormDisabled(false);
      setSelectedPrice(null);
    }
  }, [currentOrganization.activateTrialError]);

  const { bind } = useSwipe((dir) => {
    const container = containerRef.current;
    if (!container) return;

    const scrollAmount = container.offsetWidth * 0.8; // match 80% card width

    if (dir === "left") {
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    } else if (dir === "right") {
      container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    }
  });

  const trialPlan = useMemo(() => {
    const plan = subscriptionPlans.collection.find((plan) =>
      plan.prices[currency].find(
        (price) => Object.keys(price.metadata).indexOf("is_trial_plan") >= 0
      )
    );
    return plan;
  }, [subscriptionPlans.collection, currency]);

  /**
   *
   * @type {function(*, *): function(*): void}
   */
  const onSelectPlan = useCallback(
    (price, plan) => (e) => {
      // console.log("onSelectPlan", price);
      e.preventDefault();
      setFormDisabled(true);
      setSelectedPrice(price.id);
    },
    [form, setFormDisabled, setSelectedPrice]
  );

  const plans = useMemo(() => {
    const _plans = subscriptionPlans.collection.map((plan, idx) => {
      const price = plan.prices[currency].find(
        (i) => i.recurring.interval === "month"
      );

      return (
        <SubscriptionPlanColumn
          key={plan.id}
          plan={plan}
          price={price}
          showAction={true}
          actionLabel={"Start Free Trial"}
          showImage={false}
          onAction={onSelectPlan}
          disabled={formDisabled}
        />
      );
    });

    _plans.unshift(
      <SubscriptionPlanColumn
        key={"freeplan"}
        plan={FreePlanConfig}
        price={FreePlanPrice}
        showAction={true}
        actionLabel={"Continue FREE"}
        showImage={false}
        onAction={onSelectPlan}
        disabled={formDisabled}
      />
    );

    return _plans;
  }, [currency, formDisabled, onSelectPlan]);

  const trialPlanPricing = trialPlan ? (
    <div
      className={"subscription-plan-table-swipeable"}
      ref={containerRef}
      {...bind}
    >
      {plans}
      {/*<SubscriptionPlanColumn*/}
      {/*  plan={trialPlan}*/}
      {/*  price={trialPlanPrice}*/}
      {/*  showAction={false}*/}
      {/*  showImage={false}*/}
      {/*  onClick={() => {*/}
      {/*    setFormField("plan", trialPlan.id);*/}
      {/*  }}*/}
      {/*/>*/}
    </div>
  ) : null;

  return (
    <div>
      <h3 className="account-title">Try Pro Free for 14 Days</h3>
      <p className="text-muted">
        <strong>No credit card required. No obligation to buy.</strong>
      </p>
      <form className={"mb-5"}>
        <h4>Get full access to:</h4>
        {trialPlanPricing}
      </form>

      <p className={"text-secondary"}>
        By clicking "Start your free trial", you'll activate 14 days of full Pro
        access—no billing, no credit card.
        <br />
        After the trial, keep using the free version.
      </p>
    </div>
  );
};

export default ActivateTrialStep;
